'use client';

import { useState } from 'react';
import Link from 'next/link';
import {
  Alert,
  Anchor,
  Box,
  Button,
  Container,
  Divider,
  Group,
  PasswordInput,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { hasLength, isEmail, useForm } from '@mantine/form';
import { signInAction } from '@/app/actions/auth';

export default function Login({ searchParams }: { searchParams: { error?: string } }) {
  const [error, setError] = useState<string | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const form = useForm({
    initialValues: {
      email: '',
      password: '',
    },
    validate: {
      email: isEmail('Invalid email address'),
      password: hasLength({ min: 8 }, 'Password must be at least 8 characters long'),
    },
  });

  const handleSubmit = async (values: { email: string; password: string }) => {
    setIsSubmitted(true);
    await signInAction(values);
    setIsSubmitted(false);
  };

  return (
    <Container size="xs">
      <Box
        mt="xl"
        component="form"
        onSubmit={form.onSubmit(handleSubmit)}
        style={{ display: 'flex', flexDirection: 'column', gap: 'md' }}
      >
        <Title order={1} fw={150}>
          Sign in
        </Title>
        <Divider my="sm" />
        <Text size="sm" c="dimmed">
          Don't have an account?{' '}
          <Anchor component={Link} href="/">
            Contact Us
          </Anchor>
        </Text>
        <TextInput
          label="Email"
          placeholder="you@example.com"
          required
          {...form.getInputProps('email')}
        />

        {/* <Group align="apart"> */}
        <PasswordInput
          label="Password"
          placeholder="Your password"
          required
          {...form.getInputProps('password')}
        />
        <Anchor mt={4} component={Link} href="/forgot-password" size="xs">
          Forgot Password?
        </Anchor>
        {/* </Group> */}
        <Button type="submit" mt={12} w={100} disabled={isSubmitted}>
          Sign in
        </Button>
        {error && (
          <Alert title="Error" my="md" color="red">
            {error}
          </Alert>
        )}
        {searchParams.error && (
          <Alert title="Error" color="red" mt="md">
            {searchParams.error}
          </Alert>
        )}
      </Box>
    </Container>
  );
}
